import './List.css';
import Item from '../Item/Item'

const List = (props) => {
    return (
        <div className='list'>
            <img src='./images/banner.jpg' alt='banner' />
            {props.datos.map((producto, index) => 
                {
                if(producto.Category == props.selec || props.selec == "Todos"
                    && producto.Category != "") {
                    return <Item
                                key={index}
                                name={producto.Name}
                                description={producto.Description}
                                price={producto.Price}
                                image={producto.Image}
                                link={producto.Link}
                            />
                }}
            )}
        </div>
    );
}

export default List;